import { ImageProps } from "../types/image";
import { Product, ProductUpdate, SalesUnit } from "../types/product";
import { ResponseMeta, ResponseWarningQueries } from "../types/response";

import ApiService from "./ApiService";

type ProductsResponse = {
  data: Product[];
} & ResponseMeta &
  ResponseWarningQueries;

type IncludesProps = {
  documents?: ImageProps[];
};

export type ProductByIdResponse = {
  data: Product;
  includes?: IncludesProps;
} & ResponseMeta &
  ResponseWarningQueries;

type ProductParams = {
  search?: string;
  sort?: string;
  page?: number;
  perPage?: number;
  isActive?: boolean;
  source?: "pestix" | "sevdesk";
};

type ProductUnitsResponse = {
  data: SalesUnit[];
}

const ProductService = {
  GetProducts: async (params?: ProductParams): Promise<ProductsResponse> => {
    return ApiService.Get("product-management/products", {
      ...params
    });
  },

  GetSevdeskProducts: async (): Promise<ProductsResponse> => {
    return ApiService.Get(`sevdesk/products`);
  },

  GetProduct: async (productId: string): Promise<ProductByIdResponse> => {
    return ApiService.GetById(
      `${productId}?include=documents`,
      "product-management/products"
    );
  },

  GetProductUnits: async (): Promise<ProductUnitsResponse> => {
    return ApiService.Get("product-management/units");
  },

  CreateProduct: async (data: ProductUpdate): Promise<ProductByIdResponse> => {
    return ApiService.Post("product-management/products", data);
  },

  UpdateProduct: async (productId: string, data: Partial<ProductUpdate>): Promise<ProductByIdResponse> => {
    return ApiService.Patch(`product-management/products/${productId}`, data);
  },
  ToggleProductVisibility: async (productId: string, data: { isHidden: boolean }): Promise<ProductByIdResponse> => {
    return ApiService.Patch(`product-management/products/${productId}/visibility`, data);
  },
};

export default ProductService;
